/* mega-menu.js */

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.mega-navbar-wrapper');
  if (!wrapper) return;

  const navbar = document.querySelector('.mega-navbar');
  const navItems = document.querySelectorAll('.mega-nav-item');
  const overlay = document.querySelector('.mega-overlay');
  const isDesktop = () => window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
  const hasPanel = (item) => !!(item && item.querySelector('.mega-panel'));
  
  // Desktop Menu Toggle (kept for mobile/click fallback)
  window.toggleNav = function(id) {
    const item = document.getElementById(id);
    if (!item) return;
    if (!hasPanel(item)) return;

    if (isDesktop()) return;
    if (item.classList.contains('open')) {
      closeAll();
    } else {
      closeAll();
      item.classList.add('open');
      wrapper.classList.add('has-open');
    }
  };

  window.closeAll = function() {
    navItems.forEach(item => item.classList.remove('open'));
    wrapper.classList.remove('has-open');
  };

  // Desktop: open on hover (not click)
  function openItem(item) {
    if (!item) return;
    if (!hasPanel(item)) return;
    closeAll();
    item.classList.add('open');
    wrapper.classList.add('has-open');
  }

  if (navItems.length) {
    navItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        if (!hasPanel(item)) {
          closeAll();
          return;
        }
        openItem(item);
      });
    });
    if (navbar) {
      navbar.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeAll();
      });
    } else {
      wrapper.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeAll();
      });
    }
  }

  // Close on overlay click
  if (overlay) {
    overlay.addEventListener('click', () => {
      closeAll();
      if (drawer) {
        drawer.classList.remove('open');
        overlay.style.zIndex = '';
      }
    });
  }

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
      if (drawer) {
        drawer.classList.remove('open');
        if (overlay) overlay.style.zIndex = '';
      }
    }
  });

  // Close when clicking outside of navbar wrapper or mobile drawer
  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target) && !e.target.closest('.mega-mobile-drawer')) {
      closeAll();
      if (drawer) {
        drawer.classList.remove('open');
        if (overlay) overlay.style.zIndex = '';
      }
    }
  });

  // Brand Sidebar Switching
  window.switchBrand = function(brandId, event) {
    // Prevent default anchor link behavior
    if (event) event.preventDefault();
    
    // Find closest mega panel to scope the tab switching
    const panel = event.currentTarget.closest('.mega-panel-inner');
    if (!panel) return;

    // Reset buttons
    const btns = panel.querySelectorAll('.mega-sidebar-btn');
    btns.forEach(btn => btn.classList.remove('active'));
    
    // Set clicked button active
    event.currentTarget.classList.add('active');

    // Reset content panels
    const tabPanels = panel.querySelectorAll('.mega-tab-panel');
    tabPanels.forEach(p => p.classList.remove('active'));

    // Set targeted panel active
    const targetPanel = panel.querySelector('#panel-' + brandId);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  };

  // Mobile Drawer Logic
  const hamburger = document.querySelector('.mega-hamburger');
  const drawer = document.querySelector('.mega-mobile-drawer');
  const closeDrawerBtn = document.querySelector('.mega-close-drawer');

  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      drawer.classList.add('open');
      if (overlay) {
        wrapper.classList.add('has-open'); // Reusing overlay
        overlay.style.zIndex = '299'; // Ensure it's behind drawer but above page
      }
    });
  }

  if (closeDrawerBtn && drawer) {
    closeDrawerBtn.addEventListener('click', () => {
      drawer.classList.remove('open');
      closeAll(); // Removes overlay
      if (overlay) overlay.style.zIndex = '';
    });
  }

  // Mobile Accordion
  window.toggleAccordion = function(el) {
    const item = el.closest('.mega-accordion-item');
    if (!item) return;
    const willOpen = !item.classList.contains('open');
    item.classList.toggle('open');

    // On mobile, opening a parent accordion should reveal all nested mega content.
    const nestedItems = item.querySelectorAll('.mega-accordion-item');
    nestedItems.forEach((nested) => {
      nested.classList.toggle('open', willOpen);
    });
  };
});
